const MenuData = {"menu": {
  "breakfast_sandwich": [
    ["Egg",3.09],
    ["Egg & Cheese",4.39],
    ["Bacon, Egg & Cheese",6.75],
    ["Ham, Egg & Cheese",6.75],
    ["Sausage, Egg & Cheese",6.75],
    ["Kielbasa, Egg & Cheese",6.75],
    ["Pepper, Egg & Cheese",5.40],
    ["Western",7.70],
    ["Steak, Egg & Cheese",9.75],
    ["Pastrami, Egg & Cheese",7.75],
    ["Turkey, Egg & Cheese",7.75]
  ],
  "breakfast_assortment":  [
    ["Danish & Turnovers",3.50],
    ["Assorted Muffins",2.50],
    ["Assorted Bagels",1.50],
    ["-        with butter",1.85],
    ["-        with cream cheese",3.35],
    ["Butter Roll",1.50],
    ["-        with peanut butter",1.85],
    ["-        add banana",2.50],
    ["Croissant",1.25],
    ["-        with butter",1.95],
    ["Donuts",1.95]
  ],
  "hot_menu": [
    ["Meatloaf",8.99,17.49],
    ["Chicken Cutlet",8.99,17.49],
    ["Grilled Chicken",8.99,17.49],
    ["Buffalo Chicken",8.99,17.49],
    ["Teriyaki Chicken",8.99,17.49],
    ["Steak & Cheese",8.99,17.49],
    ["Meatball & Cheese",8.99,17.49],
    ["Pot Roast",8.99,17.49],
    ["Pulled Pork",8.99,17.49]
  ],
  "cold_menu": [
    ["B.L.T.",7.49,14.99,null],
    ["Bologna",7.99,15.99,4.69],
    ["Capicola",8.49,16.99,8.99],
    ["Chicken Breast",8.49,16.99,9.29],
    ["Cranberry, Walnut & Chic Salad",8.49,16.99,null],
    ["Egg Salad",8.25,16.50,null],
    ["Genoa Salami",8.29,16.58,8.29],
    ["Domestic Ham",7.20,14.40,4.29],
    ["Honey Ham",8.25,16.50,9.99],
    ["Honey Turkey",8.25,16.50,9.99],
    ["Imported Ham",8.25,16.50,8.99],
    ["Liverwurst",7.70,15.40,6.29],
    ["Pastrami",8.49,16.99,11.99],
    ["Pepperoni",8.25,16.50,8.29],
    ["Roast Beef",8.75,17.50,13.49],
    ["Seafood Salad",8.25,16.50,null],
    ["Tuna",7.99,15.99,null],
    ["Turkey",8.25,16.50,8.99],
    ["Black Pepper Turkey",8.25,16.50,9.99],
    ["Veal Loaf",7.45,14.90,6.29],
    ["Veggie",7.25,14.50,null]
  ],
  "breakfast_specials": [
    ["Slim's Revenge","Kielbasa, egg and cheddar on wrap with hash brown and sour cream", 8.25, null, null],
    ["Alicia's Bagel", "Ham, bacon, egg and cheese on bagel", 7.99, null, null],
    ["Meatlover", "Ham, bacon, sausage, egg and cheese", 9.25, null, null],
    ["Davey B", "Ham, egg and cheese with peppers and hot sauce", 7.25, null, null],
    ["Rise and Shine", "Egg, pepper jack cheese, roasted and jalapeno peppers, with onion, salsa, hot sauce and refried beans", 7.25, null, "With steak for  ...  $8.99"],
    ["Steaker", "Steak, cheddar, and egg on bagel", 9.75, null, null],
    ["Farmhouse", "Sausage, egg, cheddar, jalapeno and hash brown", 7.75, null, null],
    ["Rigger Wrap", "Egg, double kielbasa and Swiss on wrap", 8.75, null, null],
    ["Brian's Rigger Wrap", "Ham, egg, cheddar, swiss, provolone and hash brown", 8.75, null, null],
    ["Pete's Pick", "Double bacon, double egg and double cheese on wrap", 8.99, null, null],
    ["Barnyard", "Ham, bacon, sausage, egg, provolone, and hash brown on wrap", 10.35, null, null],
    ["Eastern", "Kielbasa, egg, peppers, onion and cheese", 7.99, null, null],
    ["JFK", "Pastrami, egg, swiss cheese and honey dijon", 7.75, null, null],
    ["The Yogi", "Sausage, bacon, egg, cheddar cheese, hash brown, hot sauce on cheddar bagel", 8.99, null, null],
    ["The Mountainman", "Chicken cutlet, egg, pepperjack, bacon, BBQ sauce", 10.35, null, null],
    ["Jim McMuffin", "Ham, egg, cheddar, hash brown on an English muffin", 7.75, null, null],
    ["The Veg", "Spinach, red onion, roasted pepper, jack cheese, hot sauce, hash brown on a wrap", 6.75, null, null]
  ],
  "lunch_specials": [
    ["Rocking Roast Beef","Roast beef, cheese, lettuce, tomato, onion, banana peppers and horse radish sauce", 8.75, 17.50, null, 'cold'],
    ["Kickin Chickin","Buffalo chicken salad, cheese, bacon, lettuce, tomato, bleu cheese", 9.99, 18.99, null, 'both'],
    ["Jake","Honey ham, honey turkey, cheese, lettuce, bacon, banana peppers and honey mustard", 9.50, 18.50, null, 'cold'],
    ["The Trucker","Chicken teriyaki, cheddar, onion, lettuce, tomato, ranch and sour cream", 8.99, 17.49, null, 'hot'],
    ["Billy Club","Chicken cutlet, pepper jack cheese, banana pepper, lettuce, tomatoes, bacon and honey mustard", 9.99, 18.99, null, 'hot'],
    ["Steve's Tasty Tuna","Tuna, cheddar, lettuce, onion, jalapeno, bacon, honey mustard", 9.50, 18.50, null, 'cold'],
    ["Bedell Wrap","Buffalo chicken, pepper jack, honey mustard, roasted peppers, jalapeno peppers, and banana peppers, lettuce", 8.99, 17.49, null, 'hot'],
    ["Spicy Italian","Ham, salami, capicola, pepperoni, provolone, lettuce, tomato, onion, jalapenos, hot sauce and horse radish sauce", 8.99, 17.49, null, 'cold'],
    ["Dave's #9","Steak & cheese, peppers, mushrooms and onions", 8.99, 17.49, null, 'hot'],
    ["Ragin Cajun","Black pepper, turkey cheese, lettuce, tomato, onion, banana and red and green peppers, mayo and bacon, salt and pepper", 9.50, 18.50, null, 'cold'],
    ["Joe's Meat","Meatloaf, provolone, jalapenos, ketchup and horseradish", 8.99, 17.49, null, 'hot'],
    ["Cobuzzi","Chicken, teriyaki, cheese, lettuce, onion and ranch", 8.99, 17.49, null, 'hot'],
    ["Jim's Italian Combo","Ham, salami, capicola, pepperoni, provolone, lettuce, tomato, peppers, onion, olives, mayo, oil/vinegar, salt/pepper and oregano", 8.99, 17.49, null, 'cold'],
    ["All American","Ham, turkey, swiss, lettuce, tomato, onion, banana peppers, oil/vinegar and peppercorn dressing", 8.99, 17.49, null, 'cold'],
    ["Belly Buster","Ham, turkey, salami, pepperoni, bacon, lettuce, tomato, pepper jack cheese, onion, peppers, oil/vinegar and peppercorn dressing", 9.99, 18.99, null, 'cold'],
    ["Cordon Bleu Club","Chicken cutlet topped with ham, provolone, bacon, lettuce and ranch dressing", 10.25, 19.50, "No Bacon ... 8.99    17.49", 'hot'],
    ["Roast Beefer","Roast beef with melted swiss, mushrooms, lettuce, tomato and mayo", 8.75, 17.50, null, 'hot'],
    ["Spanky's Firefighter","Grilled chicken with peppers, onions, garlic and olice oil with cheese", 8.99, 17.49, null, 'hot'],
    ["Timmy T","Meatball, pepperoni, provolone with peppers and onions", 9.50, 18.50, null, 'hot'],
    ["Cuban","Pulled pork with ham, swiss, pickles, spicy mustard and mayo", 9.50, 18.50, null, 'hot'],
    ["Gonzadu","Prosciutto, capicola, provolone, lettuce, tomato, roasted red peppers, oil/vinegar and oregano", 8.50, 16.99, null, 'cold'],
    ["Greek","Salami, onions and peppers topped with feta cheese, lettuce, tomato, oil/vinegar and oregano", 8.25, 15.99, null, 'both'],
    ["The 'Hammer'", "Steak with cheddar, bacon, onions and BBQ sauce", 9.99, 19.50, null, 'hot'],
    ["Max 'D'","Honey turkey, salami, pepperoni, lettuce, tomato, pepper jack, onion, red roasted peppers, bacon, garlic salt and pepper with chipolte sauce", 9.99, 19.50, null, 'cold'],
    ["Cameron","Deli chicken breast with provolone, onion, red roasted peppers, lettuce and chipolte sauce", 8.50, 16.50, null, 'both'],
    ["Ray's Scotch","Turkey, american cheese, onion, red roasted peppers, sauerkraut and spicy mustard", 8.25, 15.99, null, 'both'],
    ["Harvey Banger","Honey ham, honey turkey, cheddar, lettuce, tomato, red onion, cucumbers, raw peppers and honey Dijon", 8.50, 16.50, null, 'cold'],
    ["The Mistake","Pot roast, swiss, ham, mayo, spicy mustard with banana peppers", 9.50, 18.50, null, 'hot'],
    ["Ted's Blazing","Buffalo sliced chicken breast, pepper jack cheese, banana and jalepeno peppers, lettuce, tomato, red onion and chipolte mayo", 8.50, 16.50, null, 'both'],
    ["Mavani Veggie","Pepper jack cheese, (onion, jalapeno, roasted peppers, banana peppers, olives, cucumbers, pickles, tomato), with lettuce and ranch", 7.99, 14.50, null, 'cold'],
    ["Spencer","Oven roasted turkey with italian cheese, bacon, onion, banana peppers and ranch dressing", 9.99, 18.50, null, 'cold'],
    ["Big Mac (meatloaf)","Cheddar, lettuce, tomato, onion, pickle, thousand island dressing", 8.99, 17.49, null, 'hot'],
    ["Pat's Special","Eggplant, mozzarella, red roasted peppers, lettuce, tomato, mayo and oil/vinegar", 7.50, 14.50, null, 'hot'],
    ["Julies Italian","Ham, salami, capicola, pepperoni, italian cheese, lettuce, tomato, red onion, red peppers, olives, mayo and oil/vinegar", 8.99, 17.49, null, 'cold'],
    ["Packed Pastrami","Cheddar, red onions, durkee onions, bacon and coleslaw", 9.99, 19.50, null, 'hot'],
    ["Ultimate BLT","Honey turkey, cheddar, lettuce, tomato, mayo and bacon", 9.50, 18.50, null, 'hot'],
    ["Crabby Gabby","Steak, cheddar, banana peppers, bacon, lettuce, tomato, mayo and BBQ sauce", 9.99, 18.99, null, 'hot'],
    ["Timmy P","Chicken cutlet, sauce, italian cheese, oil, spices, pepperoni", 9.50, 18.50, null, 'hot'],
    ["The Yogi","Deli chicken breast, feta cheese, spinach, red onion, tomato, spices, oil/vinegar on a wrap", 8.49, 16.99, null, 'cold'],
    ["Suzi Q","Chicken cutlet, mozzarella cheese, garlic, red roasted peppers, spinach, tomato, spices & italian dressing", 8.99, 17.49, null, 'hot'],
    ["Air Connection","Buffalo chicken, cheddar, bacon, lettuce, tomato, ranch, hot sauce", 9.99, 18.99, null, 'hot'],
    ["Shay Z","Chicken cutlet, jack cheese, jalapenos, red & green peppers, onions, bacon & ranch",  9.99, 18.99, null, 'hot'],
    ["“Mott” Zarella","Chicken cutlet, mozzarella, sauce, bacon, garlic, spices, oregano, oil & grated cheese",  9.99, 18.99, null, 'hot'],
    ["The Wayside","Pulled pork, cheddar, coleslaw, macaroni and cheese on wrap", 9.99, 19.50, null, 'hot'],
    ["Quick Lane","Chicken cutlet, provolone, BBQ sauce, red roasted peppers", 8.99, 17.49, null, 'hot'],
    ["Acme Monaco","Deli chicken breast, prosciutto, mozzarella, italian seasoning, light oil/vinegar, hot sauce, red roasted peppers & tomato", 8.50, 16.99, null, 'both'],
    ["The I.T.","Honey ham, provolone, lettuce, tomato, red onion, pickles & peppercorn dressing", 8.25, 15.99, null, 'cold'],
    ["Claudia's Combo","Roast beef, turkey, swiss, banana peppers, coleslaw & thousand island on ciabatta", 8.99, 17.49, null, 'both'],
    ["Jules","Grilled chicken, feta, spinach, tomato, red onion, raw peppers, cucumber, honey mustard, hummus", 8.99, 17.49, null, 'both'],
    ["Zakk","Chicken cutlet, prosciutto, mozzarella, oil, oregano, banana peppers, light sauce", 9.50, 18.50, null, 'hot'],
    ["Kerry","Roast beef, swiss, red roasted peppers, garlic spread, oil & spices", 8.75, 17.50, null, 'hot'],
    ["Wawa","Oven roasted turkey, durkee onion, bacon, cheese, mayo", 9.99, 19.50, null, 'cold'],
    ["Chicken Ceasar Wrap","Crispy or grilled chicken, lettuce, spinach, croutons, tomato, olives, ceasar dressing", 9.99, null, null, 'cold'],
    ["Chicken Parmesan","Crispy chicken cutlet, mozzarella, sauce, oil, spices", 8.99, 17.49, null, 'hot'],
    ["Monte Cristo","Honey ham and turkey, swiss, thousand island on french toast", 8.50, null, null, 'hot'],
    ["Lucette","Steak, horseradish cheese, onion, jalapenos, banana peppers, mayo, hot sauce", 8.99, 17.49, null, 'hot'],
    ["Harley","Tuna, italian cheese, tomato, cucumbers, mushroom", 8.50, 16.99, null, 'cold'],
    ["Gopher","Pulled pork, roast beef, lettuce, tomato, swiss, onion, banana peppers, mayo, horseradish mayo", 9.50, 18.50, null, 'hot'],
    ["Megaliscious","Honey ham, cheddar, lettuce, tomato, red onion, red roasted peppers, spices, honey dijon", 8.50, 16.99, null, 'both'],
    ["Pastrami Rueben","Pastrami, swiss, sauerkraut, thoasand island dressing", 8.99, 17.49, null, 'hot'],
    ["Saucy Complainer","Cranberry chicken walnut salad, lettuce, durkee onion, bbq, horseradish mayo", 8.49, 16.99, null, 'cold'],
    ["New Yorker","Roast beef, swiss, bacon, lettuce, tomato, red onion, spicy mustard, horseradish", 9.99, 19.50, null, 'both'],
    ["Rachel's Ham","Ham, lettuce, tomato, pickles, red onion, red roasted, cheese, mayo, oil", 8.25, 16.49, null, 'cold'],
    ["Black Bean Burger","Jack cheese, spinach, tomato, red onion, red roasted, chipotle", 7.99, 15.50, null, 'hot'],
    ["Scarletti","Grilled chicken, mozz, garlic, red onion, lettuce, tomato, balsamic", 8.99, 17.49, null, 'hot']
  ],
  "side_snacks": [
    ["Nuts (All)", 10.29],
    ["Swedish Fish", 6.99],
    ["Trail Mix", 9.99],
    ["Lettuce", 2.69],
    ["Tomato, raw peppers, onions", 2.99],
    ["Lettuce", 2.69],
    ["Potatoes", 1.00]
  ],
  "single_snacks": [
    ["Pickle", 1.25],
    ["Lemon / Limes", 1.50],
    ["Cucumbers", 2.00],
    ["Package Wraps", 6.99]
  ],
  "cheeses": [
    ["Land O'Lakes American", 6.29],
    ["Cheddar", 6.99],
    ["Horseradish", 10.19],
    ["Italian Sharp", 8.99],
    ["Provolone", 6.99],
    ["Swiss", 7.69],
    ["Pepper Jack", 6.99]
  ],
  "tossed_salads": [
    ["Tossed", 5.99, 8.99],
    ["Chicken Tossed", 9.75, 12.75],
    ["Buffalo Chicken", 9.75, 12.75],
    ["Chicken Teriyaki", 9.75, 12.75],
    ["Chef", 9.75, 12.75]
  ],
  "side_salads": [
    ["4 Bean", 6.99],
    ["Apple Crisp", 8.99],
    ["Buffalo Chicken Salad", 11.69],
    ["Chicken", 11.69],
    ["Coleslaw", 6.99],
    ["Cranberry Walnut Chicken", 11.69],
    ["Devil Eggs", 2.59],
    ["Egg", 6.99],
    ["Fruit", 7.99],
    ["Hardboiled Eggs", 2.72],
    ["Macaroni", 7.99],
    ["Marinated Mushrooms", 7.99],
    ["Pasta", 7.99],
    ["Potato", 7.99],
    ["Rice Pudding", 6.99],
    ["Seafood", 9.99],
    ["Stuffed Prosciutto Peppers", 11.99],
    ["Tortellini", 7.99],
    ["Tuna", 9.99],
    ["Tuna Macaroni Salad", 11.69]
  ],
  "soup": [
    ["Soups of the Day", 5.15, 6.19]
  ],
  "hot_dogs": [
    ["Martin Rosols Hot Dogs", 3.75]
  ]
}};

export default MenuData;